import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface IPanelQueryResult {
  id: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class FilterPanelQueryService {
  // No dependencies required for this service

  getPanelInputData(_query: string, _target: string): Observable<IPanelQueryResult[]> {
    // Return empty array as placeholder - original implementation used GraphQL
    return of([]);
    // return this.graphQl.getData(ClientName.Gateway, gql`${query}`).pipe(
    //     map((response) => {
    //         const items = response.data[target].items;
    //         return items.map(item => ({ id: item.id, name: item.displayName ?? item.name }));
    //     })
    //   );
  }
}
